import {Action} from '@ngrx/store';
import {FileEntry} from '@app/core/models/fileEntry.model';
import {Pagination} from '@app/core/models/pagination.model';
import {IQOPagination} from '@quickorder/angular-web-lib/lib/types/interfaces/q-o-pagination.interface';

export enum EFileEntryActions {
	PostFileEntries = '[FileEntry] Post File Entries',
	PostFileEntriesSuccess = '[FileEntry] Post File Entries Success',
	GetFileEntry = '[FileEntry] Get File Entry',
	GetFileEntrySuccess = '[FileEntry] Get File Entry Success',
	RemoveFileEntry = '[FileEntry] Remove File Entry',
	AddFileEntries = '[FileEntry] Add File Entries',
	GetFileEntries = '[FileEntry] Get File Entries',
	GetFileEntriesSuccess = '[FileEntry] Get File Entries Success',
	ClearFileEntries = '[FileEntry] Clear File Entries',
}

export class PostFileEntries implements Action {
	public readonly type = EFileEntryActions.PostFileEntries;

	constructor(public files: File[]) {
	}
}

export class PostFileEntriesSuccess implements Action {
	public readonly type = EFileEntryActions.PostFileEntriesSuccess;

	constructor(public fileEntries: FileEntry[]) {
	}
}

export class GetFileEntry implements Action {
	public readonly type = EFileEntryActions.GetFileEntry;

	constructor(public id: number) {
	}
}

export class GetFileEntrySuccess implements Action {
	public readonly type = EFileEntryActions.GetFileEntrySuccess;

	constructor(public fileEntry: FileEntry) {
	}
}

export class RemoveFileEntry implements Action {
	public readonly type = EFileEntryActions.RemoveFileEntry;

	constructor(public fileEntry: FileEntry) {
	}
}

export class AddFileEntries implements Action {
	public readonly type = EFileEntryActions.AddFileEntries;

	constructor(public fileEntries: FileEntry[]) {
	}
}

export class ClearFileEntries implements Action {
	public readonly type = EFileEntryActions.ClearFileEntries;

	constructor() {
	}
}

export class GetFileEntries implements Action {
	public readonly type = EFileEntryActions.GetFileEntries;

	constructor(public page: number, public pageSize: number = 5, public isNotAttached: boolean = false) {
	}
}

export class GetFileEntriesSuccess implements Action {
	public readonly type = EFileEntryActions.GetFileEntriesSuccess;

	constructor(public files: FileEntry[], public pagination: IQOPagination) {
	}
}

export type FileEntryActions =
	PostFileEntries |
	PostFileEntriesSuccess |
	GetFileEntry |
	GetFileEntrySuccess |
	ClearFileEntries |
	RemoveFileEntry |
	AddFileEntries |
	GetFileEntries |
	GetFileEntriesSuccess
	;
